import React from 'react';
// import { useState } from 'react';

import { Box} from '@mui/material';
import { Container } from '@mui/material';

import AddBankForm from '../Components/AddBankForm';
// import AddCompanyForm from '../../../Components/Companies/AddCompanyForm';


export default function AddBankPage() {

  // HQ COMPANY STATE OBJECT

   
  
  return (
    // component="main"
    <>
    <Box sx={{ flexGrow: 1, p: 3 }}>
        {/* <SideBarNav/> */}
        <Container>
            <AddBankForm/>
            {/* <AddCompanyForm
              addWhatCompanyTitle={"Bank"}
              hqCompanyObject={bankObjct}
              handleNameChange={handleNameChange}
              handleEmailChange={handleEmailChange}
              handlePhoneChange={handlePhoneChange}
              handleAddressChange={handleAddressChange}
              handleAddressTwoChange={handleAddressTwoChange}
              handleCityChange={handleCityChange}
              handleStateChange={handleStateChange}
              handleZipChange={handleZipChange}
              submitNewHqCompany={submitNewBank}
            /> */}
        </Container>
    </Box>
    
    </>
  )
}
